export interface HeroSlide {
  id: string;
  mediaId: string;
  kicker: string;
  title: string;
  subtitle: string;
  image: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "h-1",
    mediaId: "m-001",
    kicker: "本周焦点 · 科幻巨制",
    title: "星海归途",
    subtitle: "当最后一艘方舟驶向星海，人类在归途中重新学会仰望。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%2C%20a%20lone%20starship%20drifting%20toward%20a%20vast%20swirling%20nebula%20and%20distant%20planets%2C%20deep%20navy%20and%20indigo%20cosmos%20with%20warm%20amber%20star%20glow%2C%20volumetric%20light%20rays%2C%20dramatic%20scale%2C%20atmospheric%20film%20still%2C%20high%20detail&width=1920&height=900&seq=hero-001&orientation=landscape",
  },
  {
    id: "h-2",
    mediaId: "m-002",
    kicker: "悬疑佳作 · 口碑之选",
    title: "暗夜追凶",
    subtitle: "每个雨夜，城市都在替凶手保守秘密。",
    image:
      "https://readdy.ai/api/search-image?query=Neo-noir%20cinematic%20cityscape%20at%20night%20in%20heavy%20rain%2C%20wet%20asphalt%20reflecting%20neon%20signs%20and%20streetlights%2C%20mysterious%20moody%20atmosphere%2C%20teal%20and%20warm%20orange%20bokeh%2C%20anamorphic%20film%20still%2C%20high%20detail&width=1920&height=900&seq=hero-002&orientation=landscape",
  },
  {
    id: "h-3",
    mediaId: "m-003",
    kicker: "温情力作 · 年度必看",
    title: "山那边的风",
    subtitle: "有些话，走了很远的路才说得出口。",
    image:
      "https://readdy.ai/api/search-image?query=Breathtaking%20cinematic%20landscape%20of%20misty%20terraced%20mountains%20at%20golden%20sunrise%2C%20a%20winding%20earthen%20path%20and%20a%20tiny%20lone%20figure%2C%20soft%20morning%20haze%2C%20emerald%20green%20and%20warm%20amber%20tones%2C%20serene%20poetic%20film%20still%2C%20high%20detail&width=1920&height=900&seq=hero-003&orientation=landscape",
  },
];